import React, { Suspense } from "react";
import PackageHeader from "./PackageHeader";
import PackageImageGallerySection from "./PackageImageGallerySection";
import FareAndEnquirySection from "./FareAndEnquirySection";
import TabAndContentSection from "./TabAndContentSection";
import DetailsContent from "./DetailsContent";
import useFetchPackageDetails from "../hooks/useFetchPackageDetails";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const StaticPackageShimmer = React.lazy(() => import("../StaticPackageShimmer"));

const PackageDetails = () => {
    const { packageDetails, isLoading, packageKey } = useFetchPackageDetails();    
    const resourceKeys = useSelector((state) => state.culture.language);

    const culture = useSelector((state) => state.culture.currentCulture);

    return (
        <>
            <PackageHeader packageDetails={packageDetails}/>
            {isLoading && (
                <Suspense fallback={<div>Loading...</div>}>
                    <StaticPackageShimmer />
                </Suspense>
            )}
        <section className="ContentArea">
        <div className="container minHeight">
            {!isLoading && !packageDetails.ItenaryDetails && (
                <div className="no_result d-flex flex-column justify-content-center align-items-center mt-5">
                    <i className="no_result_package"></i>
                    <h4>{resourceKeys.no_result_found}</h4>
                    <p>The package you have selected is currenly unvailable</p>
                    <Link
                        to={process.env.REACT_APP_BASE_URL + culture +"/package-result"}
                        className="button_theme no_resultBtn"
                    >
                        {resourceKeys.back}
                    </Link>
                    </div>
            )}
            {!isLoading && packageDetails.ItenaryDetails && (
                        <div className="row">
                            <PackageImageGallerySection packageDetails={packageDetails} resourceKeys={resourceKeys}/>
                            {/* Trip fare section start here */}
                            <FareAndEnquirySection packageDetails={packageDetails} fareKey={packageKey} resourceKeys={resourceKeys} />
                            {/* Trip fare section ends here */}
                            <TabAndContentSection packageDetails = {packageDetails} resourceKeys={resourceKeys}/>
                            {/* Details content */}
                            <DetailsContent ItineraryDetails={packageDetails.ItenaryDetails} resourceKeys={resourceKeys}/>
                            {/* Details content */}
                        </div>
            )}
        </div>
        </section>
        </>
    );
};

export default PackageDetails;
